import {
  updateJogo,
  updatePassatempo,
  type JogoUpdatePayload,
  type PassatempoUpdatePayload,
} from '../../../services/admin';

/**
 * Metadados do passo 3 do "+ Novo jogo". Nenhum caminho de criação (gerador, editor,
 * import) aceita edição/tema/dificuldade, então eles são gravados com um PATCH logo
 * depois que o registro passa a existir — nunca antes.
 */
export interface CreationMeta {
  edicoesId?: number;
  temaId?: number;
  dificuldadeId?: number;
}

export type CreationSource = 'passatempo' | 'jogo';

export function isEmptyCreationMeta(meta: CreationMeta): boolean {
  return meta.edicoesId === undefined && meta.temaId === undefined && meta.dificuldadeId === undefined;
}

/** Só os campos definidos: um PATCH com `undefined` não pode apagar nada. */
function defined<T extends object>(payload: T): T {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined),
  ) as T;
}

/** Grava o meta no registro recém-criado, pela API da tabela certa. Meta vazio = nada. */
export async function applyCreationMeta(
  source: CreationSource,
  id: number,
  meta: CreationMeta,
): Promise<void> {
  if (isEmptyCreationMeta(meta)) return;
  if (source === 'passatempo') {
    const payload: PassatempoUpdatePayload = defined({
      edicoesId: meta.edicoesId,
      temasPassatemposId: meta.temaId,
      dificuldadesId: meta.dificuldadeId,
    });
    await updatePassatempo(id, payload);
    return;
  }
  const payload: JogoUpdatePayload = defined({
    edicoesId: meta.edicoesId,
    idTema: meta.temaId,
    idDificuldade: meta.dificuldadeId,
  });
  await updateJogo(id, payload);
}
